import { Link } from "react-router-dom";

/**
 * Sema brand lockup. Renders the dark-ink lockup on light backgrounds and the
 * white lockup on dark backgrounds (theme toggled via the `.dark` class on
 * <html>). Set `mark` to render just the square mark instead of the lockup.
 */
export function SemaLogo({ to = "/", className = "", imgClassName = "h-7", mark = false, testid = "sema-logo" }) {
  const dark = mark ? "/brand/sema-mark-white.png" : "/brand/sema-lockup-white.webp";
  const light = mark ? "/brand/sema-mark.png" : "/brand/sema-lockup.webp";
  const content = (
    <>
      <img src={light} alt="Sema" className={`${imgClassName} w-auto object-contain dark:hidden`} draggable={false} />
      <img src={dark} alt="Sema" className={`${imgClassName} hidden w-auto object-contain dark:block`} draggable={false} />
    </>
  );
  if (!to) {
    return <span data-testid={testid} className={`inline-flex items-center ${className}`}>{content}</span>;
  }
  return (
    <Link to={to} data-testid={testid} className={`inline-flex items-center ${className}`} aria-label="Sema home">
      {content}
    </Link>
  );
}
